import omit from 'ramda/src/omit'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import wait from 'root/src/shared/util/wait'

import { CREATE_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import mixpanel from 'root/src/client/logic/analytics/mixpanel'
import { mixpanelEvents } from 'root/src/shared/constants/mixpanel'

export default formData => async (dispatch) => {
	const response = await dispatch(apiRequest(CREATE_PROJECT, omit(['pledgeAmount'], formData)))
	mixpanel.track(mixpanelEvents.pledgeSkip)
	mixpanel.track(mixpanelEvents.projectCreated)
	// this wait is here because projects aren't instantly created/pledged with elasticSearch
	await wait(1000)
	return { ...response, skipPledge: true }
}
